export default __webpack_public_path__ + "static/media/td.f6cbcf06.jpg";